import { render, staticRenderFns } from "./TemplateGoldenmetrics.vue?vue&type=template&id=3fe6d104"
import script from "./TemplateGoldenmetrics.vue?vue&type=script&lang=js"
export * from "./TemplateGoldenmetrics.vue?vue&type=script&lang=js"
import style0 from "./TemplateGoldenmetrics.vue?vue&type=style&index=0&id=3fe6d104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports